import { Alert } from "@mantine/core";

import { IconExclamationMark } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

interface BirthingPostpartumFlowsheetNoticeProps {
  /** Called when the user dismisses the notice via the close control. */
  onDismiss: () => void;
}

/**
 * Explains that client and newborn postpartum flowsheets unlock after body delivery is recorded on the Birthing form.
 */
export default function BirthingPostpartumFlowsheetNotice({
  onDismiss,
}: BirthingPostpartumFlowsheetNoticeProps) {
  return (
    <Alert
      color="orange"
      variant="light"
      withCloseButton
      onClose={onDismiss}
      data-testid="birthing-postpartum-flowsheet-notice"
      icon={<IconExclamationMark size={16} stroke={2.5} />}
      title="Postpartum flowsheets appear after body delivery"
      styles={{
        root: {
          backgroundColor: "var(--mantine-color-orange-0)",
          border: "none",
        },
        title: { color: "var(--mantine-color-orange-9)", fontWeight: 700 },
        icon: {
          border: "2px solid var(--mantine-color-orange-9)",
          color: "var(--mantine-color-orange-9)",
          borderRadius: "50%",
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 2,
        },
        closeButton: { color: "var(--mantine-color-orange-9)", width: "16px", height: "16px" },
      }}
    >
      <TextWrapper size="sm" c="dark.9">
        Once you record the body delivery time, the client and newborn postpartum flowsheets will
        become available.
      </TextWrapper>
    </Alert>
  );
}
